import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';
import { copyToClipBoard } from '../../../utils';

import { linkIsFileInS3, downloadFile} from '../../../utils';

const ResourceCard = (props) => {

    const { resource, toggleResource } = props
    return (
        <div className="resource-card">
            <div className="resource-card-header">
                {
                    linkIsFileInS3(resource.url) ?
                    <a onClick={()=> downloadFile(resource.url)} className="resource-card-title" >
                      {resource.title || resource.url || "No Title"}
                    </a>
                    :
                    <a href={resource.url} target="_blank" rel="noreferrer" rel="noreferrer" className="resource-card-title">
                     {resource.title || resource.url || "No Title"}
                    </a>
                }
                {
                  !linkIsFileInS3(resource.url) &&
                  <IconButton sx={{margin: "0 0 0 .5em"}} onClick={()=>copyToClipBoard(resource.url)}>
                      <ContentCopyIcon style={{ color:'#F9BD02'}} />
                  </IconButton>
                }
            </div>
                <div>
                    {resource.description}
                </div>
        </div>
    )
}

export default ResourceCard